module.exports = __webpack_public_path__ + "img/cybersecurity-img-2.123e8995.jpg";